import * as tslib_1 from "tslib";
import m from 'mithril';
import { View } from './view';
var Portal = /** @class */ (function (_super) {
    tslib_1.__extends(Portal, _super);
    function Portal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.node = document.createElement('div');
        return _this;
    }
    Portal.prototype.onCreate = function () {
        var _this = this;
        document.body.appendChild(this.node);
        m.mount(this.node, { view: function () { return _this.children; } });
    };
    Portal.prototype.onRemove = function () {
        m.mount(this.node, { view: function () { return null; } });
        document.body.removeChild(this.node);
    };
    Portal.prototype.render = function () {
        return null;
    };
    return Portal;
}(View));
export { Portal };
